import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import on from 'dojo/on';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import Edit from '../../moreCore/UI/Edit/Edit';
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import Toaster from '../../moreCore/UI/Toaster_TS/Toaster';
import { MainCatalogTypes, MainCatalogs_Classes } from "../_loadingHelpers/MainCatalogTypes";
import { ToasterHelpers } from "../../more/Helpers";
class MainCatalogsEditorBase extends compose(_WidgetBaseSP, _TabEnabledMixin) {

    errorContainer: HTMLElement;
    errorMessage: HTMLElement;

    toaster: MdsLax<InstanceType<typeof Toaster>>;

    protected formData: any = null;
    protected originalData: string = "";

    protected labelAttribute: string = "$Displayname";

    protected entityClass: MainCatalogs_Classes = null;
    protected isOnlyNewEntity: boolean = false;
    protected isStandAloneEdit: boolean = false;

    protected timeoutHandle: number = null;

    editMainContainer: HTMLElement;
    editFormHeader: HTMLElement;
    closeButton: HTMLButtonElement;
    saveButton: HTMLButtonElement;
    protected editFormLeftSection: HTMLElement;
    protected editFormRightSection: HTMLElement;

    protected entityId: string;

    setHeading(title: string) {
        if (title) {
            if (this.editFormHeader) {
                this.UiModder.domAttr.set(this.editFormHeader, "innerHTML", title);
                this.hideNode(this.editFormHeader, false);

            } else {
                this.editFormHeader = this.UiModder.domConstruct.create("h4", {
                    "innerHTML": title
                }, this.domNode, "first");
            }

        } else {
            if (this.editFormHeader) {
                this.hideNode(this.editFormHeader);
            }
        }
    }

    loadCatalogEntityData(className: string,
        entityId: string,
        callbackResponse: (response: object) => void,
        callbackError: (error: object) => void): void {

        let requestUrl = window.appRoot + "MainCatalogsEditor/GetCatalogEntityData";
        //this.StandbyStart();

        this.RequestManager.post(
            requestUrl,
            {
                className: className,
                entityId: entityId
            },
            callbackResponse,
            callbackError,
            false // sync
        );

        this.entityId = entityId;
    }

    _onLoadCatalogEntityDataError(err): void {

        this.StandbyStop();


        if (this.isStandAloneEdit) {

            this._showErrorMessage(err.Message);
            if (this.editFormLeftSection) {
                this.UiModder.domClass.add(this.editFormLeftSection, "w3-disabled");
            }

            if (this.editFormRightSection) {
                this.UiModder.domClass.add(this.editFormRightSection, "w3-disabled");
            }
        } else {

            this.emit("CatalogEntityData_Error", err.Message);
        }
    }

    _onClickButtonSave(evt?: MouseEvent): void {


        if (this.isValid()) {

            this.saveCatalogData(this.entityClass, JSON.stringify(this.formData),
                lang.hitch(this, this._onSaveCatalogDataResponse),
                lang.hitch(this, this._onSaveCatalogDataError));
        }
    }

    _onSaveCatalogDataError(err: more.requestErrorMessage): void {

        this.StandbyStop();

        //this.emit("CatalogEntityData_Error", err.Message);
        this._showErrorMessage( err.Message);
    }

    protected __delayDisableSaveButton(disable: boolean): void {
        if (this.timeoutHandle != null) {
            clearTimeout(this.timeoutHandle);
            this.timeoutHandle = null;
        }

        this.timeoutHandle = setTimeout(lang.hitch(this, this.disableSaveButton, disable), 200);
    }

    disableSaveButton(disable: boolean): void {
        if (this.saveButton == null) {
            return; //@TODO: früher abbrechen wenn der dlg icht geöffnet wurde... dann ist kein close notwendig
        }
        if (disable) {

            this.UiModder.domClass.add(this.saveButton, "w3-disabled");
        } else {

            this.UiModder.domClass.remove(this.saveButton, "w3-disabled");
        }
    }

    protected updateHeading(data: string | Object) {
        if (typeof (data) == "string") {
            this.setHeading(data);
        } else if( data) {

            if (this.labelAttribute && data[this.labelAttribute]) {
                this.setHeading(data[this.labelAttribute]);
            } else if (data["_displayname"]) {
                this.setHeading(data["_displayname"]);
            } else if (data["$Displayname"]) {
                this.setHeading(data["$Displayname"]);
            }
        }
    }

    _onLoadCatalogEntityDataResponse(response: any): void {

        this.StandbyStop();
        console.debug("RESPONSE", response);


        this.updateHeading(response);

        this.StandbyStart();

        this.emit("CatalogEntityData_Response");

        this.prepareFormData(response);
    }

    _onSaveCatalogDataResponse(response: any): void {

        let id = response.entityId;

        if (this.isOnlyNewEntity === true) {

            this.createNewEntity(this.isOnlyNewEntity);
        } else {

            this.getEditFormInfo(id);
        }

        this.getEditFormInfo(id);


        this.StandbyStop();

        this.toaster.addToast(this.translations["General_SavingSuccessful"], ToasterHelpers.ToasterIcons.confirmCheck);

        this.emit("CatalogEntityData_Save", id);

    //    let dlg = new GenericDialog();

    //    dlg.destroyOnClose = true;
    //    this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "600px");
    //    this.UiModder.domStyle.set(dlg.modalDlgContentNode, "margin-top", "100px");

    //    dlg.show(this.translations["MainCatalogsEditor_SaveDlg_Message"], this.translations["MainCatalogsEditor_SaveDlg_Header"], null, "fas fa-info-circle", "ok");

        
    }

    _showErrorMessage(msg?: string) {

        if (msg) {

            let dlg = new GenericDialog;
            dlg._setHeaderAttr("Loading failed");
            dlg._setCloseBtnAttr(true);
            dlg._setYesBtnAttr(false);
            dlg._setNoBtnAttr(false);
            dlg._setOkBtnAttr(false);

            dlg._setTextIconAttr("fas fa-warning-circle");
            
            msg ? this.errorMessage.innerHTML = msg : this.errorMessage.innerHTML = "...error occured";
            dlg._setContentAttr(msg);

            dlg.show();
        } else {

            
        }
    }
    protected isDirty: boolean = false;
    checkDirty(): void {

        let isDirty = JSON.stringify(this.formData) !== this.originalData && this.originalData !== "";

        this.isDirty = isDirty;
        this.emitDirty(isDirty);
        this.__delayDisableSaveButton(!isDirty);
    }

    fixNewLineInMultilineEdit(editInput: MdsLax<InstanceType<typeof Edit>>): void {

        let value: string = editInput.getValue();

        if (value) {

            value = value.replace(/[\r\n]/g, "\r\n");
        }

        editInput.setValue(value, true);
    }

    _onCloseRequest() {
        let hasChanged = this.isDirty === true;

        if (hasChanged) {

            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(this.translations["General_AskSavePendingChanges"],
                this.translations["General_PendingChanges"],
                "",
                "",
                "yesnocancel",
                lang.hitch(this, this._confirmCallback));

            return false;

        } else {
            return true;
        }
    }

    private _confirmCallback(result) {
        if (result == -1) { // nein
            this.closeTab();
        } else if (result == 0) { // cancel

        }
        else {
            this._onClickButtonSave();
            on(this, "CatalogEntityData_Save", lang.hitch(this, this.closeTab))
        }
    }

    protected _onClickButtonClose(evt: MouseEvent): void {
        this.close();
    }

    close(): void {
        this.prepareFormData();

        this.emit("CatalogEntityData_Close");

    }

    //_onSaveCatalogDataResponse(response: any): void {
    //    // wird überschrieben in Child-Klassen
    //    alert("_onSaveCatalogDataResponse not set in child! " + this.id);
    //}
    isValid(): boolean {
        // wird überschrieben in Child-Klassen
        alert("isValid not set in child! " + this.id);

        return false;
    }
    protected createNewEntity(onlyNew: boolean): void {
        this.entityId = null;

            this.prepareFormData();
            this.isOnlyNewEntity = onlyNew;
            this.isStandAloneEdit = true;
            this.editFormHeader.innerHTML = this.translations["MainCatalogsEditor_Form_MainHeader_New"];

        this.UiModder.domClass.add(this.editMainContainer, "w3-margin");
    }

    protected editExistingEntity(statusId: string): void {


        this.isStandAloneEdit = true;
        this.UiModder.domClass.add(this.editMainContainer, "w3-margin");

        if (statusId) {

            this.getEditFormInfo(statusId);
            this.UiModder.domClass.remove(this.editFormLeftSection, "w3-disabled");
            this.UiModder.domClass.remove(this.editFormRightSection, "w3-disabled");
        } else {

            this._showErrorMessage(this.translations["MainCatalogsEditor_Form_Error_NoId"]);
            this.UiModder.domClass.add(this.editFormLeftSection, "w3-disabled");
            this.UiModder.domClass.add(this.editFormRightSection, "w3-disabled");
        }
    }


    protected _onChangeInputDataGeneric(): void {
        //debugger;
        this.serializeFormData();
        this.checkDirty();
    }

    protected serializeFormData(): void {
        // wird überschrieben in Child-Klassen
        alert("serializeFormData not set in child! " + this.id);
    }

    setCloseButton(bValue: boolean): void {
        this.UiModder.domClass.toggle(this.closeButton, "w3-hide", bValue !== true);        
    }

    getEditFormInfo(entityId: string): void {
        if (entityId) {

            this.StandbyStart();

            this.loadCatalogEntityData(this.entityClass, entityId,
                lang.hitch(this, this._onLoadCatalogEntityDataResponse),
                lang.hitch(this, this._onLoadCatalogEntityDataError));

            if (this.isStandAloneEdit) this.editFormHeader.innerHTML = this.translations["MainCatalogsEditor_Form_MainHeader_Edit"];
        } else {

            this.emit("CatalogEntityData_NoId");
            this.prepareFormData();
        }
    }

    prepareFormData(data?: any): void {
        // wird überschrieben in Child-Klassen
        alert("prepareFormData not set in child! " + this.id);
    }


    saveCatalogData(className: string,
        jsonData: string,
        callbackResponse: (response: object) => void,
        callbackError: (error: object) => void): void {

        let requestUrl = window.appRoot + "MainCatalogsEditor/SaveCatalogEntityData";

        this.RequestManager.post(
            requestUrl,
            {
                className: className,
                jsonData: jsonData
            },
            callbackResponse,
            callbackError,
            false // sync
        );
    }

    protected indicateErrorOnInput(element: Node | MdsLax<InstanceType<typeof _WidgetBaseSP>>, bgClass: string = "w3-pale-red") {

        let otherBgClass: string;
        if (!element) return;

        let node: Node = null;
        if (element instanceof Node) {
            node = element;
        } else if (element && element["declaredClass"]) {
            let widget: any = element;

            node = widget.domNode;

        //    switch (element["declaredClass"]) {
        //        case "MultiSelect":
        //        case "SearchSelect":
        //            node = element["outerInput"];
        //            break;

        //        default:
        //            node = element["inputNode"];
        //            break;
        //    }
        }

        if (!node) return;

        if (this.UiModder.domClass.contains(node, "mds-bg-yellow")) otherBgClass = "mds-bg-yellow";
        if (this.UiModder.domClass.contains(node, "mds-bg-green")) otherBgClass = "mds-bg-green";
        if (otherBgClass) this.UiModder.domClass.remove(node, otherBgClass);

        let interval = setInterval(() => {
            if (this.UiModder.domClass.contains(node, bgClass)) {
                this.UiModder.domClass.remove(node, bgClass);
            } else {
                this.UiModder.domClass.add(node, bgClass);
            }
        }, 250);

        setTimeout(() => {
            clearInterval(interval);
            this.UiModder.domClass.remove(node, bgClass);
            if (otherBgClass) this.UiModder.domClass.add(node, otherBgClass);
        }, 1500);
    }

    protected _onClick_Inactive(evt) {

        let requestUrl = window.appRoot + "MainCatalogsEditor/SetEntityAsInactive";
        //this.StandbyStart();

        this.RequestManager.post(
            requestUrl,
            {
                jsonData: null // TODO class, ID
            },
            lang.hitch(this, this._onSetEntityAsInactiveResponse),
            lang.hitch(this, this._onSetEntityAsInactiveError),
            false // sync
        );
    }

    protected _onSetEntityAsInactiveResponse(): void {

    }

    protected _onSetEntityAsInactiveError(err): void {

        alert(err.Message);
    }

    protected _onClick_Delete(evt) {
        alert("delete noch nicht verfügbar!");
    }

    _onEmbedding(): void {
        if (this.isEmbeddedInTab) {
            if (this.hasUserRole("ADMIN")) {
                //this.createDefaultButton("delete", lang.hitch(this, this._onClick_Delete));
                this.createDefaultButton("deactivate", lang.hitch(this, this._onClick_Inactive));
            }
        }
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.toaster = new Toaster();

        this.requestContextButton({
            callback: lang.hitch(this, this._onClickButtonSave),
            label: "Save",
            placement: "actionbar",
            permanent: false
        })
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MainCatalogsEditorBase);